import React from 'react'
import scrollTo from 'gatsby-plugin-smoothscroll'
import { Link, SEO, StarsSection } from 'newComponents'
import Layout from '../components/layout'
import MarketoForm from '../components/MarketoForm'
import CtaArrow from '../components/ctaArrow'
import '../styles/partners.scss'

import toggleDouble from '../images/illustrations/small/toggles-tiny.svg'
import code from '../images/illustrations/small/code-tiny-screen.svg'
import nodes from '../images/illustrations/small/nodes.svg'
import customRoles from '../images/illustrations/small/custom-roles2.svg'
import team from '../images/illustrations/small/three-team.svg'
import puzzle from '../images/illustrations/small/puzzle-tiny.svg'

import github from '../images/partners/github.svg'
import atlassian from '../images/partners/atlassian.svg'
import armory from '../images/partners/armory.png'
import appdynamics from '../images/partners/appdynamics.svg'
import HashiCorp from '../images/partners/HashiCorp.svg'
import honeycomb from '../images/partners/honeycomb.svg'
import logdna from '../images/partners/logdna.svg'
import rollbar from '../images/partners/rollbar.svg'

const partners = [github, HashiCorp, logdna, honeycomb, rollbar, appdynamics, atlassian, armory]

const Partners = () => (
  <Layout>
    <SEO
      title="Partner Program"
      description=" LaunchDarkly is building the future of feature management. Our partners are some of the most innovative tech companies in the world. Join us and help redefine how modern software is built."
    />
    <StarsSection className="section is-xlarge bg-dark">
      <div className="container content columns">
        <div className="column is-12 has-text-centered has-text-left-mobile">
          <h1 className="title">Let’s Build Better Software, Together</h1>
          <p className="text-large partners-subtitle">
            Join our Partner Program and gain exclusive access to the resources you need to get your solutions in the
            hands of more teams.
          </p>
          <button className="button is-large is-primary border-radius-2" onClick={() => scrollTo('#partner-form')}>
            BECOME A PARTNER
          </button>
        </div>
      </div>
    </StarsSection>
    <section className="section is-xlarge">
      <div className="container content">
        <div className="has-text-centered-desktop columns">
          <div className="column">
            <h2>Why Partner with LaunchDarkly?</h2>
            <p className="has-text-left">
              We’re building the future of feature management, and we’re working with some of the most innovative tech
              companies in the world to create a better way to build software. We’ve{' '}
              <Link to="/policies/partner-program/" className="cta-text">
                built a program
              </Link>{' '}
              that empowers technology partners to build, launch, and go-to-market with LaunchDarkly.
            </p>
          </div>
        </div>
        <div className="columns is-multiline u-margintop-medium">
          <div className="column is-5-desktop is-12-tablet columns is-multiline">
            <div className="column icon-container aligned-bottom-container-tablet  is-2-desktop is-12-tablet is-12-mobile has-text-right-desktop">
              <img className="small-icon aligned-bottom-tablet" src={puzzle} alt="toggle icon" />
            </div>
            <div className="column">
              <h4>Integration Framework</h4>
              <p>Build your product integration directly into LaunchDarkly using our simple Integration Framework.</p>
            </div>
          </div>

          <div className="column is-6-desktop column-offset-override columns is-multiline">
            <div className="column icon-container aligned-bottom-container-tablet is-2-desktop is-12-tablet is-12-mobile has-text-right-desktop">
              <img className="small-icon aligned-bottom-tablet" src={toggleDouble} alt="custom access icon" />
            </div>
            <div className="column">
              <h4>Early Product Access</h4>
              <p>
                Unlock early access to the latest LaunchDarkly product features and gain powerful customer insights.
              </p>
            </div>
          </div>

          <div className="column is-5-desktop is-12-tablet columns is-multiline">
            <div className="column icon-container aligned-bottom-container-tablet is-2-desktop is-12-tablet is-12-mobile has-text-right-desktop">
              <img className="small-icon aligned-bottom-tablet" src={customRoles} alt="dashboard icon" />
            </div>
            <div className="column">
              <h4>Joint Marketing Opportunities</h4>
              <p>
                Jointly announce your product integration and tap into marketing opportunities like events, webinars and
                community initiatives.
              </p>
            </div>
          </div>

          <div className="column is-6-desktop is-12-tablet column-offset-override columns is-multiline">
            <div className="column icon-container aligned-bottom-container-tablet is-2-desktop is-12-tablet is-12-mobile has-text-right-desktop">
              <img className="small-icon aligned-bottom-tablet" src={nodes} alt="person icon" />
            </div>
            <div className="column">
              <h4>Joint Customer Visibility</h4>
              <p>Reach thousands of LaunchDarkly customers directly from the LaunchDarkly application.</p>
            </div>
          </div>

          <div className="column is-5-desktop is-12-tablet columns is-multiline">
            <div className="column icon-container aligned-bottom-container-tablet is-2-desktop is-12-tablet is-12-mobile has-text-right-desktop">
              <img className="small-icon aligned-bottom-tablet" src={team} alt="dashboard icon" />
            </div>
            <div className="column">
              <h4>Partnership Support</h4>
              <p>Gain dedicated access to LaunchDarkly’s Partnerships team.</p>
            </div>
          </div>

          <div className="column is-6-desktop is-12-tablet column-offset-override columns is-multiline">
            <div className="column icon-container aligned-bottom-container-tablet is-2-desktop is-12-tablet is-12-mobile has-text-right-desktop">
              <img className="small-icon aligned-bottom-tablet" src={code} alt="person icon" />
            </div>
            <div className="column">
              <h4>Technical Feedback</h4>
              <p>Receive feedback and support from LaunchDarkly on maintaining, and improving your integration.</p>
            </div>
          </div>
        </div>
        <div className="columns u-margintop-large is-multiline">
          <div className="column is-5-desktop is-12-tablet u-vertical-center">
            <div>
              <h2>Better Together</h2>
              <p>Join an industry leading group of organizations and help redefine how modern software is built.</p>
            </div>
          </div>
          <div className="column is-6-desktop is-offset-1-desktop is-12-tablet partners-logos-padding">
            <div className="columns is-multiline is-mobile">
              {partners.map((partner) => (
                <div className="column is-3">
                  <div className="partner-logos">
                    <img className="" src={partner} alt={toString(partner)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <p className="u-margintop-small partners-logos-link">
          <Link to="/integrations/">
            View All Integrations <CtaArrow />
          </Link>
        </p>
      </div>
    </section>
    <section className="bg-gradient section is-xlarge" id="partner-form">
      <div className="container content columns">
        <div className="column is-12-tablet is-6-desktop u-margin-auto">
          <div className="card formCard">
            <form>
              <h3 className="title title-black partners-card-title">Become a LaunchDarkly Partner</h3>
              <br />
              <MarketoForm formId="1496" />
              <p className="help">
                By submitting you agree to LaunchDarkly's{' '}
                <Link to="/policies/terms-of-service/" target="_blank" rel="noopener noreferrer">
                  Terms
                </Link>{' '}
                and{' '}
                <Link to="/policies/privacy/" target="_blank" rel="noopener noreferrer">
                  Privacy Policies
                </Link>
                .
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  </Layout>
)
export default Partners
